var map = {
	"./assets/PayPal.webp": 8337,
	"./assets/banners/1x-Special-Banner.gif": 3944,
	"./assets/banners/BEST_TIP.gif": 6020,
	"./assets/banners/England-Europe-Fixed-Matches-1X2.gif": 3596,
	"./assets/banners/Professional-Best-Fixed-Matches-1X2.gif": 4547,
	"./assets/banners/arrowbet.gif": 148,
	"./assets/banners/belgium-tips.gif": 5803,
	"./assets/banners/berlin.gif": 5110,
	"./assets/banners/best-tip.gif": 9198,
	"./assets/banners/besttip365.gif": 4365,
	"./assets/banners/bet-war.gif": 8266,
	"./assets/banners/bet365-fixed-matches.gif": 8934,
	"./assets/banners/bet365-fixedgames.gif": 6049,
	"./assets/banners/betconfirm.gif": 8396,
	"./assets/banners/betmechanic.gif": 1496,
	"./assets/banners/cr7.gif": 6502,
	"./assets/banners/england-picks.gif": 3666,
	"./assets/banners/englandbets.gif": 9522,
	"./assets/banners/europe-fixedmatches.gif": 8064,
	"./assets/banners/fixed1x2.gif": 7157,
	"./assets/banners/fixedmatchescorrectscore.gif": 6676,
	"./assets/banners/flairbet.gif": 4969,
	"./assets/banners/gentlemans.gif": 1317,
	"./assets/banners/highstake.gif": 2616,
	"./assets/banners/improve.gif": 1192,
	"./assets/banners/invest.gif": 4617,
	"./assets/banners/jokerpicks.gif": 5271,
	"./assets/banners/legendtip.gif": 1323,
	"./assets/banners/livescore-fixedmatches.gif": 7141,
	"./assets/banners/mafia.gif": 1215,
	"./assets/banners/maxbetfixedmatches.gif": 2525,
	"./assets/banners/mozzart.gif": 8387,
	"./assets/banners/navigator.gif": 4158,
	"./assets/banners/norway-tips.gif": 6529,
	"./assets/banners/orabet.gif": 6383,
	"./assets/banners/picksbet.gif": 5162,
	"./assets/banners/predator.gif": 4447,
	"./assets/banners/predatorr.gif": 8750,
	"./assets/banners/premium-1x2-banner.gif": 3997,
	"./assets/banners/pro1x2win.gif": 3075,
	"./assets/banners/raul-1x2.gif": 3490,
	"./assets/banners/realmadrid-bet1x2.gif": 3109,
	"./assets/banners/scandinaviafixedmatches.gif": 2313,
	"./assets/banners/scotland-bet.gif": 4026,
	"./assets/banners/shark.gif": 4900,
	"./assets/banners/shopbet.gif": 871,
	"./assets/banners/special-matches.gif": 602,
	"./assets/banners/sport-fixedmatches1x2.gif": 2193,
	"./assets/banners/supersport23.gif": 2840,
	"./assets/banners/supersport2333.gif": 4037,
	"./assets/banners/sure-wins.gif": 9893,
	"./assets/banners/swedenbet.gif": 7632,
	"./assets/banners/sydneybet.gif": 2592,
	"./assets/banners/topsbet.gif": 3211,
	"./assets/banners/turkey-tips.gif": 5041,
	"./assets/banners/viktor.gif": 9769,
	"./assets/banners/vip-fixed.gif": 6470,
	"./assets/banners/vipleader.gif": 1642,
	"./assets/banners/winning1x2.gif": 4818,
	"./assets/bitcoin.webp": 7503,
	"./assets/data/arch/free .old": 9764,
	"./assets/data/arch/free .old.json": 9764,
	"./assets/data/arch/insiders.old": 5132,
	"./assets/data/arch/insiders.old.json": 5132,
	"./assets/data/arch/tickets.old": 2804,
	"./assets/data/arch/tickets.old.json": 2804,
	"./assets/data/arch/vip.old": 1785,
	"./assets/data/arch/vip.old.json": 1785,
	"./assets/hero.jpg": 3151,
	"./assets/ins.png": 7965,
	"./assets/left-chevron.png": 9061,
	"./assets/logo.png": 6949,
	"./assets/lose.png": 4267,
	"./assets/moneygram.webp": 6625,
	"./assets/neteller.webp": 3097,
	"./assets/paypal.png": 4165,
	"./assets/skrill.webp": 9342,
	"./assets/star.png": 6101,
	"./assets/win.png": 5884,
	"./assets/wu.webp": 2579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;